import { useAuth } from "@/lib/AuthContext";
import { TEAMS as DEFAULT_TEAMS } from "@/lib/constants";

/** Returns the active guild's teams, falling back to the legacy default. */
export function useTeams() {
  const { activeGuild } = useAuth() || {};
  const teams = activeGuild?.teams;
  return Array.isArray(teams) && teams.length > 0 ? teams : DEFAULT_TEAMS;
}
